"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnD_Ble_reader = function (_BleReader) {
  _inherits(AnD_Ble_reader, _BleReader);

  function AnD_Ble_reader(device) {
    _classCallCheck(this, AnD_Ble_reader);

    var _this = _possibleConstructorReturn(this, (AnD_Ble_reader.__proto__ || Object.getPrototypeOf(AnD_Ble_reader)).call(this, device));

    _this.customService = "233BF000-5A34-1B6D-975C-000D5690ABE4";
    _this.customCharacteristic = "233BF001-5A34-1B6D-975C-000D5690ABE4";
    return _this;
  }

  _createClass(AnD_Ble_reader, [{
    key: "sendCommand",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(command) {
        var writeResult, readResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.write(this.customService, this.customCharacteristic, command.buffer);

              case 2:
                writeResult = _context.sent;

                if (!writeResult.ok) {
                  _context.next = 10;
                  break;
                }

                _context.next = 6;
                return this.read(this.customService, this.customCharacteristic);

              case 6:
                readResult = _context.sent;

                if (!readResult.ok) {
                  _context.next = 10;
                  break;
                }

                readResult.settingsArray = new Uint8Array(readResult.result);
                return _context.abrupt("return", readResult);

              case 10:
                return _context.abrupt("return", { ok: false });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendCommand(_x) {
        return _ref.apply(this, arguments);
      }

      return sendCommand;
    }()
  }, {
    key: "writeCommand",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(command) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.write(this.customService, this.customCharacteristic, command.buffer));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function writeCommand(_x2) {
        return _ref2.apply(this, arguments);
      }

      return writeCommand;
    }()
  }, {
    key: "readBufferSettings",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var byte_array, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                byte_array = new Uint8Array(3);

                byte_array[0] = 0x02; // Size of following 
                byte_array[1] = 0x00; // Type 0=read, 1=write
                byte_array[2] = 0xD6; // Command - get buffer settings

                console.log("readBufferSettings");

                _context3.next = 7;
                return this.sendCommand(byte_array);

              case 7:
                result = _context3.sent;


                result.settings = { hasBuffer: false };

                if (result.ok) {
                  if (result.settingsArray.length > 3) {
                    result.settings.hasBuffer = result.settingsArray[3] == 0 ? false : true;
                  }
                }

                console.log(result);
                return _context3.abrupt("return", result);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function readBufferSettings() {
        return _ref3.apply(this, arguments);
      }

      return readBufferSettings;
    }()
  }, {
    key: "readSettings",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var byte_array, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                byte_array = new Uint8Array(3);

                byte_array[0] = 0x02; // Size of following 
                byte_array[1] = 0x00; // Type 0=read, 1=write
                byte_array[2] = 0xDB; // Command - get settings

                console.log("readSettings");

                _context4.next = 7;
                return this.sendCommand(byte_array);

              case 7:
                result = _context4.sent;


                if (result.ok) {

                  if (result.settingsArray.length > 3) {
                    result.settings = {
                      acceleration: result.settingsArray[3],
                      unit: result.settingsArray[4] == 0 ? 'kg' : 'lbs',
                      hasBuffer: result.settingsArray[5] == 0 ? false : true,
                      currBuffer: result.settingsArray[6],
                      totalReadings: result.settingsArray[7] + (result.settingsArray[8] << 8)
                    };
                  } else {
                    result.settings = {
                      acceleration: null,
                      unit: 'lbs',
                      hasBuffer: false,
                      currBuffer: 0,
                      totalReadings: 0
                    };
                  }
                }

                console.log(result);
                return _context4.abrupt("return", result.settings);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function readSettings() {
        return _ref4.apply(this, arguments);
      }

      return readSettings;
    }()
  }, {
    key: "sendDisconnect",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var byte_array;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                byte_array = new Uint8Array(3);

                byte_array[0] = 0x02; // Size of following 
                byte_array[1] = 0x01; // Type 0=read, 1=write
                byte_array[2] = 0x03; // Command - disconnect

                console.log("sendDisconnect...");
                return _context5.abrupt("return", this.writeCommand(byte_array));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendDisconnect() {
        return _ref5.apply(this, arguments);
      }

      return sendDisconnect;
    }()
  }, {
    key: "setNumberOfMeasurements",
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(buf_size) {
        var byte_array;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // This also clears the buffer
                byte_array = new Uint8Array(4);

                byte_array[0] = 0x03; // Size of following 
                byte_array[1] = 0x01; // Type 0=read, 1=write
                byte_array[2] = 0xA6; // Command - Set Buffer
                byte_array[3] = buf_size == 0 ? 0 : 1; // Value

                console.log("setting num meas...");
                return _context6.abrupt("return", this.writeCommand(byte_array));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setNumberOfMeasurements(_x3) {
        return _ref6.apply(this, arguments);
      }

      return setNumberOfMeasurements;
    }()
  }, {
    key: "setClock",
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(date) {
        var byte_array, year;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                byte_array = new Uint8Array(7);
                year = date.getFullYear();

                byte_array[1] = (year & 0xFF00) >> 8;
                byte_array[0] = year & 0xFF;
                byte_array[2] = date.getMonth() + 1;
                byte_array[3] = date.getDate();
                byte_array[4] = date.getHours();
                byte_array[5] = date.getMinutes();
                byte_array[6] = date.getSeconds();

                console.log("setting clock...");
                return _context7.abrupt("return", this.writeWithoutResponse("1810", "2A08", byte_array.buffer));

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setClock(_x4) {
        return _ref7.apply(this, arguments);
      }

      return setClock;
    }()
  }, {
    key: "setUnits",
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(newUnit) {
        var byte_array;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                byte_array = new Uint8Array(4);

                byte_array[0] = 0x03; // Size of following 
                byte_array[1] = 0x01; // Type 0=read, 1=write
                byte_array[2] = 0x11; // Command - Set Unit
                byte_array[3] = newUnit == "kg" ? 0x00 : 0x01; // Value

                console.log("setting unit...");
                return _context8.abrupt("return", this.writeCommand(byte_array));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setUnits(_x5) {
        return _ref8.apply(this, arguments);
      }

      return setUnits;
    }()
  }, {
    key: "setClockCustom",
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(date) {
        var byte_array;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                byte_array = new Uint8Array(9);

                byte_array[0] = 0x08; // Size of following 
                byte_array[1] = 0x01; // Type 0=read, 1=write
                byte_array[2] = 0x01; // Command - Setclock
                byte_array[3] = date.getFullYear() - 2000;
                byte_array[4] = date.getMonth() + 1;
                byte_array[5] = date.getDate();
                byte_array[6] = date.getHours();
                byte_array[7] = date.getMinutes();
                byte_array[8] = date.getSeconds();

                console.log("setting date  ...");
                return _context9.abrupt("return", this.writeCommand(byte_array));

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setClockCustom(_x6) {
        return _ref9.apply(this, arguments);
      }

      return setClockCustom;
    }()
  }]);

  return AnD_Ble_reader;
}(BleReader);